module.exports = __webpack_public_path__ + "media/images/flags/32/Olympics-00f667c3bc48958d3c3a2ac7d7ce8e6e.png";